module.exports = __webpack_public_path__ + "static/media/cold s.d9f0544d.jpeg";